import {useState, useEffect} from 'react';
import {orderBy} from 'lodash-es';

export default function useSort({by, list:_list=[]}) {
  const [ sortBy, setSortBy ] = useState(by)
  const [ desc, setDesc ] = useState(false)
  const [ list, setList ] = useState(_list)
  useEffect(() => {
    let order = desc ? "desc" : "asc"
    setList(orderBy(list, [sortBy], [order]))
  }, [sortBy, desc])
  const setSort = idx => () => {
    let _desc = (sortBy === idx) ? !desc : false
    setSortBy(idx);
    setDesc(_desc);
  }
  return { sortBy, desc, setSort, list }
}
